<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.content}}</p>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">Annulla</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Ok</button>
</div>